import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const CubeSecurityContext = { id: 11, name: 'Cube Security Context' };
/**
 * Pre-defined runtime variables that can be used as values in the
 * security context key-value pairs. These are resolved at query time
 * by the data agent before being passed to the adapter.
 */
export const SECURITY_CONTEXT_VARIABLES = [
    {
        id: '$IS_NATION',
        label: 'Is National',
        description: 'Resolves to brand access level (true/false)',
    },
];
const securityContextEntrySchema = z.object({
    key: z.string(),
    value: z.string(),
});
const securityContextSchema = z.array(securityContextEntrySchema);
export const securityContext = defineFeature({
    type: FeatureType.Json,
    propName: 'security_context',
    uiName: 'securityContext',
    displayName: 'Security Context',
    description: 'Key-value pairs passed as security context to the data connection. Values can be literal strings or pre-defined variables (e.g. $IS_NATION).',
    category: CubeSecurityContext,
    areas: ['data-connection'],
    applicability: {
        providers: ['CUBEJS'],
    },
    codec: 'json-string',
    schema: securityContextSchema,
    default: [],
    isSystem: true,
    editor: 'security-context-kv',
});
export const cubeSecurityContextFeatures = [
    securityContext,
];
